import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from './../environments/environment';
import { DebugOverviewComponent } from './_debug/overview/debug-overview.component';
import { ChangePasswordComponent } from './common/component/change-password/change-password.component';
import { ExecutorGroupFormComponent } from './common/component/executor-group-form/executor-group-form.component';
import { ExecutorGroupManagerComponent } from './common/component/executor-group-manager.component/executor-group-manager.component';
import { HelpPageComponent } from './common/component/help-page/help-page.component';
import { LocationAccessGroupManagerComponent } from './common/component/location-access-group-manager/location-access-group-manager.component';
import { LocationAccessGroupFormComponent } from './common/component/location-access-group/location-access-group-form.component';
import { LoginComponent } from './common/component/login/login.component';
import { Features } from './common/model/account-definition';
import { PriceListFormComponent } from './common/component/pricelist-form/pricelist-form.component';
import { PriceListItemFormComponent } from './common/component/pricelist-item-form/pricelist-item-form.component';
import { PriceListManagerComponent } from './common/component/pricelist-item-manager/pricelist-manager.component';
import { ProfileSettingsComponent } from './common/component/profile-settings/profile-settings.component';
import { ProfileComponent } from './common/component/profile/profile.component';
import { RegisterDemoComponent } from './common/component/register-demo/register-demo.component';
import { ResetPasswordComponent } from './common/component/reset-password/reset-password.component';
import { StaircaseListComponent } from './common/component/staircase-list/staircase-list.component';
import { UserFormComponent } from './common/component/user-form/user-form.component';
import { UserGroupFormComponent } from './common/component/user-group-form/user-group-form.component';
import { UserGroupManagerComponent } from './common/component/user-group-manager/user-group-manager.component';
import { UserManagerComponent } from './common/component/user-manager/user-manager.component';
import { AnonymousGuard } from './common/service/guard/anonymous-guard.service';
import { AuthGuard } from './common/service/guard/auth-guard.service';
import { CommonPricelistsGuardService } from './common/service/guard/common-pricelists-guard.service';
import { DwellingInspectionGuard } from './common/service/guard/dwelling-inspection-guard.service';
import { ImdGuard } from './common/service/guard/imd-guard.service';
import { InvoicingGuard } from './common/service/guard/invoicing-guard.service';
import { LandlordAccountGuard } from './common/service/guard/landlord-guard.service';
import { LettingFeatureGuard } from './common/service/guard/letting-feature-guard.service';
import { LicenseHomepalDashboardGuard } from './common/service/guard/license-homepaldashboard-guard';
import { MessagesGuard } from './common/service/guard/messages-guard.service';
import { RentGuard } from './common/service/guard/rent-guard.service';
import { ImdImportAddFormComponent } from './consumption/component/import-add-form/import-add-form.component';
import { ImdImportFormComponent } from './consumption/component/import-form/import-form.component';
import { ImdImportManagerComponent } from './consumption/component/import-manager/imd-import-manager.component';
import { ImdMeterModelFormComponent } from './consumption/component/meter-model-form/meter-model-form.component';
import { ImdMeterModelManagerComponent } from './consumption/component/meter-model-manager/meter-model-manager.component';
import { ImdPriceListFormComponent } from './consumption/component/pricelist-form/pricelist-form.component';
import { ImdPriceListManagerComponent } from './consumption/component/pricelist-manager/pricelist-manager.component';
import { PendingChangesGuard } from './core/service/pending-changes.service';
import { DashboardComponent } from './dashboard/component/dashboard/dashboard.component';
import { CreateDwellingInspectionFormComponent } from './dwelling-inspection/component/create-dwelling-inspection-form/create-dwelling-inspection-form.component';
import { DwellingInspectionFormComponent } from './dwelling-inspection/component/dwelling-inspection-form/dwelling-inspection-form.component';
import { DwellingInspectionManagerComponent } from './dwelling-inspection/component/dwelling-inspection-manager/dwelling-inspection-manager.component';
import { DwellingInspectionTypeFormComponent } from './dwelling-inspection/component/dwelling-inspection-type-form/dwelling-inspection-type-form.component';
import { DwellingInspectionTypeManagerComponent } from './dwelling-inspection/component/dwelling-inspection-type-manager/dwelling-inspection-type-manager/dwelling-inspection-type-manager.component';
import { B2CSubscriptionsComponent } from './invoice/component/b2c-subscriptions/b2c-subscriptions.component';
import { AmortizationPlanDetailsComponent } from './invoice/component/amortization-plan-details/amortization-plan-details.component';
import { AmortizationPlanManagerComponent } from './invoice/component/amortization-plan-manager/amortization-plan-manager.component';
import { AmortizationPlanPaymentNoticeManagerComponent } from './invoice/component/amortization-plan-payment-notice-manager/amortization-plan-payment-notice-manager.component';
import { CreateAmortizationPlanPaymentNoticePageComponent } from './invoice/component/create-amortization-plan-payment-notice-page/create-amortization-plan-payment-notice-page.component';
import { ESignAmortizationPlanDocumentComponent } from './invoice/component/esign-amortization-plan-document/esign-amortization-plan-document.component';
import { BgMaxImportFormComponent } from './invoice/component/bg-max-import-form/bg-max-import-form.component';
import { BgPaymentManagerComponent } from './invoice/component/bg-payment-manager/bg-payment-manager.component';
import { ContactBalanceTransactionListComponent } from './invoice/component/contact-balance-transaction-list/contact-balance-transaction-list.component';
import { CreateInvoiceFormComponent } from './invoice/component/create-invoice-form/create-invoice-form.component';
import { CreateLeaseAgreementInvoicesComponent } from './rent/component/create-lease-agreement-invoices/create-lease-agreement-invoices.component';
import { DebtCollectionManagerComponent } from './invoice/component/debt-collection-manager/debt-collection-manager.component';
import { DebtCollectionFormComponent } from './invoice/component/debt-collection.form/debt-collection-form.component';
import { DirectDebitLogManagerComponent } from './invoice/component/direct-debit-log-manager/direct-debit-log-manager.component';
import { DirectDebitComponent } from './invoice/component/direct-debit/direct-debit.component';
import { IncorrectPaymentFormComponent } from './invoice/component/incorrect-payment-form/incorrect-payment-form.component';
import { IncorrectPaymentListComponent } from './invoice/component/incorrect-payment-list/incorrect-payment-list.component';
import { InvoiceFormComponent } from './invoice/component/invoice-form/invoice-form.component';
import { InvoiceListComponent } from './invoice/component/invoice-list/invoice-list.component';
import { InvoiceReminderListComponent } from './invoice/component/invoice-reminder-list/invoice-reminder-list.component';
import { InvoiceRowGroupFormComponent } from './invoice/component/invoice-row-group-form/invoice-row-group-form.component';
import { InvoiceRowGroupMultiSelectManagerComponent } from './invoice/component/invoice-row-group-manager/invoice-row-group-manager.component';
import { LeaseAgreementInvoicesComponent } from './invoice/component/lease-agreement-invoices/lease-agreement-invoices.component';
import { PrintOrderManagerComponent } from './invoice/component/print-order-manager/print-order-manager.component';
import { RentalObjectInvoicesComponent } from './invoice/component/rental-object-invoices/rental-object-invoices.component';
import { TenantInvoicesComponent } from './invoice/component/tenant-invoices/tenant-invoices.component';
import { UnhandledBankTransactionFormComponent } from './invoice/component/unhandled-bank-transaction-form/unhandled-bank-transaction-form.component';
import { UnhandledBankTransactionImportManagerComponent } from './invoice/component/unhandled-bank-transactions-manager/bank-transaction-import-manager.component';
import { LettingAdvertismentFormComponent } from './letting/component/letting-advertisment-form/letting-advertisment-form.component';
import { LettingAdvertismentParkingFormComponent } from './letting/component/letting-advertisment-parking-form/letting-advertisment-parking-form.component';
import { LettingAdvertismentPremisesFormComponent } from './letting/component/letting-advertisment-premises-form/letting-advertisment-premises-form.component';
import { LettingAdvertismentGuard } from './letting/service/guard/letting-advertisment-guard.service';
import { EmailFormComponent } from './message/component/email-form/email-form.component';
import { LetterFormComponent } from './message/component/letter-form-component/letter-form-component.component';
import {
  EmailManagerComponent,
  MailManagerComponent,
  PostManagerComponent,
  SmsManagerComponent,
} from './message/component/object-manager/mail-manager.component';
import { PostFormComponent } from './message/component/post-form/post-form.component';
import { SendGenericEmailFormComponent } from './message/component/send-generic-email-form/send-generic-email-form.component';
import { SendSingleNewEmailFormComponent } from './message/component/send-single-new-email-form/send-single-new-email-form.component';
import { SendTenantEmailFormComponent } from './message/component/send-tenant-email-form/send-tenant-email-form.component';
import { SendTenantEmailsComponent } from './message/component/send-tenant-emails/send-tenant-emails.component';
import { SendTenantMailsFormComponent } from './message/component/send-tenant-mails-form/send-tenant-maisl-form.component';
import { SendTenantMailsComponent } from './message/component/send-tenant-mails/send-tenant-mails.component';
import { SendTenantSMSFormComponent } from './message/component/send-tenant-sms-form/send-tenant-sms-form.component';
import { SendTenantSmsComponent } from './message/component/send-tenant-sms/send-tenant-sms.component';
import { SmsFormComponent } from './message/component/sms-form/sms-form.component';
import { CompanyMortgageFormComponent } from './mortgage/component/company-mortgage-form/company-mortgage-form.component';
import { CompanyMortgageManagerComponent } from './mortgage/component/company-mortgage-manager/company-mortgage-manager.component';
import { CreditInstituteFormComponent } from './mortgage/component/credit-institute-form/credit-institute-form.component';
import { CreditInstituteManagerComponent } from './mortgage/component/credit-institute-manager/credit-institute-manager.component';
import { MortgageGuard } from './mortgage/service/guard/mortgage-guard.service';
import { SystemOverviewComponent } from './overview/component/overview/system-overview.component';
import { AppendixFormComponent } from './rent/component/appendix-form/appendix-form.component';
import { AppendixManagerComponent } from './rent/component/appendix-manager/appendix-manager.component';
import { ArticleFormComponent } from './rent/component/article-form/article-form.component';
import { ArticleGroupFormComponent } from './rent/component/article-group-form/article-group-form.component';
import { ArticleGroupMultiSelectManagerComponent } from './rent/component/article-group-manager/article-group-manager.component';
import { ArticleMultiSelectManagerComponent } from './rent/component/article-manager/article-manager.component';
import { BlockContractFormComponent } from './rent/component/block-contract-form/block-contract-form.component';
import { BlockContractManagerComponent } from './rent/component/block-contract-manager/block-contract-manager.component';
import { BrfPreTransferComponent } from './rent/component/brf-pre-transfer/brf-pre-transfer.component';
import { BrfTransferComponent } from './rent/component/brf-transfer/brf-transfer.component';
import { BuildingDocumentManagerComponent } from './rent/component/building-document-manager/building-document-manager.component';
import { BuildingFormComponent } from './rent/component/building-form/building-form.component';
import { BuildingManagerComponent } from './rent/component/building-manager/building-manager.component';
import { BuildingSpaceTypeFormComponent } from './rent/component/building-space-type-form/building-space-type-form.component';
import { BuildingSpaceTypeManagerComponent } from './rent/component/building-space-type-manager/building-space-type-manager.component';
import { LettingFeatureFormComponent } from './rent/component/letting-feature-form/letting-feature-form.component';
import { LettingFeatureManagerComponent } from './rent/component/letting-feature-manager/letting-feature-manager.component';
import { CompanyFormComponent } from './rent/component/company-form/company-form.component';
import { CompanyManagerComponent } from './rent/component/company-manager/company-manager.component';
import { ContactFormComponent } from './rent/component/contact-form/contact-form.component';
import { ContactManagerComponent } from './rent/component/contact-manager/contact-manager.component';
import { ControlData55FormComponent } from './rent/component/control-data-55-form/control-data-55-form.component';
import { ControlDataExportFormComponent } from './rent/component/control-data-export-form/control-data-export-form.component';
import { ControlDatExportManagerComponent } from './rent/component/control-data-export-manager/control-data-export-manager.component';
import { CooperativeHousingContractFormComponent } from './rent/component/cooperative-housing-contract-form/cooperative-housing-contract-form.component';
import { CooperativeHousingContractManagerComponent } from './rent/component/cooperative-housing-contract-manager/cooperative-housing-contract-manager.component';
import { CooperativeHousingTransferFormComponent } from './rent/component/cooperative-housing-transfer-form/cooperative-housing-transfer-form.component';
import { CooperativeHousingTransferManagerComponent } from './rent/component/cooperative-housing-transfer-manager/cooperative-housing-transfer-manager.component';
import { CustomPropertyFormComponent } from './rent/component/custom-property-form/custom-property-form.component';
import { CustomPropertyManagerComponent } from './rent/component/custom-property-manager/custom-property-manager.component';
import { DwellingContractFormComponent } from './rent/component/dwelling-contract-form/dwelling-contract-form.component';
import { DwellingContractManagerComponent } from './rent/component/dwelling-contract-manager/dwelling-contract-manager.component';
import { DwellingFormComponent } from './rent/component/dwelling-form/dwelling-form.component';
import { DwellingRentalObjectManagerComponent } from './rent/component/dwelling-rental-object-manager/dwelling-rental-object-manager.component';
import { ESignKeyRecieptDocumentComponent } from './rent/component/esign-key-reciept-document/esign-key-reciept-document.component';
import { ESignLeaseAgreementDocumentComponent } from './rent/component/esign-lease-agreemeent-document/esign-lease-agreement-document.component';
import { ESignatureErrandFormComponent } from './rent/component/esignature-errand-form/esignature-errand-form.component';
import { EsignatureErrandManagerComponent } from './rent/component/esignature-errand-manager/esignature-errand-manager.component';
import { FeeChangeAddFormComponent } from './rent/component/fee-change-add-form/fee-change-add-form.component';
import { FeeChangeManagerComponent } from './rent/component/fee-change-manager/fee-change-manager.component';
import { FeeChangeFormComponent } from './rent/component/fee-change.form/fee-change-form.component';
import { FortnoxComponent } from './rent/component/fortnox/fortnox.component';
import { IndexClauseSettingsFormComponent } from './rent/component/index-clause-settings-form/index-clause-settings-form.component';
import { IndexClauseSettingsManagerComponent } from './rent/component/index-clause-settings-manager/index-clause-settings-manager.component';
import { KeyTypeFormComponent } from './rent/component/key-type-form/key-type-form.component';
import { KeyTypeManagerComponent } from './rent/component/key-type-manager/key-type-manager.component';
import { LeaseAgreementDocumentManagerComponent } from './rent/component/lease-agreement-document-manager/lease-agreement-document-manager.component';
import { LeaseAgreementRentPeriodManagerComponent } from './rent/component/lease-agreement-rent-period-manager/lease-agreement-rent-period-manager.component';
import { ObjectComponentCategoryFormComponent } from './rent/component/object-component-category-form/object-component-category-form.component';
import { ObjectComponentCategoryManagerComponent } from './rent/component/object-component-category-manager/object-component-category-manager.component';
import { RentalObjectTypeManagerComponent } from './rent/component/object-manager/object-manager.component';
import { OtherContractFormComponent } from './rent/component/other-contract-form/other-contract-form.component';
import { OtherContractManagerComponent } from './rent/component/other-contract-manager/other-contract-manager.component';
import { OtherRentalObjectFormComponent } from './rent/component/other-rental-object-form/other-rental-object-form.component';
import { OtherRentalObjectManagerComponent } from './rent/component/other-rental-object-manager/other-rental-object-manager.component';
import { ParkingContractFormComponent } from './rent/component/parking-contract-form/parking-contract-form.component';
import { ParkingContractManagerComponent } from './rent/component/parking-contract-manager/parking-contract-manager.component';
import { ParkingFormComponent } from './rent/component/parking-form/parking-form.component';
import { ParkingRentalObjectManagerComponent } from './rent/component/parking-rental-object-manager/parking-rental-object-manager.component';
import { PremisesContractFormComponent } from './rent/component/premises-contract-form/premises-contract-form.component';
import { PremisesContractManagerComponent } from './rent/component/premises-contract-manager/premises-contract-manager.component';
import { PremisesFormComponent } from './rent/component/premises-form/premises-form.component';
import { PremisesRentalObjectManagerComponent } from './rent/component/premises-rental-object-manager/premises-rental-object-manager.component';
import { PropertyFormComponent } from './rent/component/property-form/property-form.component';
import { PropertyManagerComponent } from './rent/component/property-manager/property-manager.component';
import { RentApplicationFormComponent } from './rent/component/rent-application-form/rent-application-form.component';
import { RentApplicationManagerComponent } from './rent/component/rent-application-manager/rent-application-manager.component';
import { RentalChangesComponent } from './rent/component/rental-changes/rental-changes.component';
import { RentalObjectDocumentManagerComponent } from './rent/component/rental-object-document-manager/rental-object-document-manager.component';
import { RentalObjectKeyManagerComponent } from './rent/component/rental-object-key-manager/rental-objekt-key-manager.component';
import { RentalObjectKeyFormComponent } from './rent/component/rental-object-key/rental-object-key-form.component';
import { RentalObjectTypeFormComponent } from './rent/component/rental-object-type-form/rental-object-type-form.component';
import { SendToHomeqFormComponent } from './rent/component/send-to-homeq-form/send-to-homeq-form.component';
import { TerminateLeaseAgreementComponent } from './rent/component/terminate-lease-agreement/terminate-lease-agreement.component';
import { VacantPeriodDwellingManagerComponent } from './rent/component/vacant-period-dwelling-manager/vacant-period-dwelling-manager.component';
import { VacantPeriodOtherManagerComponent } from './rent/component/vacant-period-other-manager/vacant-period-other-manager.component';
import { VacantPeriodParkingManagerComponent } from './rent/component/vacant-period-parking-manager/vacant-period-parking-manager.component';
import { VacantPeriodPremisesManagerComponent } from './rent/component/vacant-period-premises-manager/vacant-period-premises-manager.component';
import { VoidLeaseAgreementComponent } from './rent/component/void-lease-agreement/void-lease-agreement.component';
import { LeaseAgreementStatus } from './rent/model/const/enums';
import { AccountBalancePerInvoiceComponent } from './report/component/account-balance-per-invoice/account-balance-per-invoice.component';
import { HomepalDashboardsComponent } from './report/component/homepal-dashboards/homepal-dashboards.component';
import { MembershipListComponent } from './report/component/membership-list/membership-list.component';
import { MonthAnalysisAmountComponent } from './report/component/month-analysis-amount/month-analysis-amount.component';
import { NotFullyPaidInvoiceComponent } from './report/component/not-fully-paid-invoice/not-fully-paid-invoice.component';
import { PropertyViewComponent } from './report/component/property-view/property-view.component';
import { ReasonablenessControlComponent } from './report/component/reasonableness-control/reasonableness-control.component';
import { RentRollComponent } from './report/component/rent-roll/rent-roll.component';
import { RentalObjectRentLossReportComponent } from './report/component/rental-object-rent-loss/rental-object-rent-loss.component';
import { StaircaseReportComponent } from './report/component/staircase-report/staircase-report.component';
import { TaxReductionReportComponent } from './report/component/tax-reduction-report/tax-reduction-report.component';
import { VatReportComponent } from './report/component/vat-report/vat-report.component';
import { VoluntaryTaxLiabilityComponent } from './report/component/voluntary-tax-liability/voluntary-tax-liability.component';
import { PageNotFoundComponent } from './root/component/page-not-found/page-not-found.component';
import { InvoicedPerRentalObjectComponent } from './report/component/invoiced-per-rental-object/invoiced-per-rental-object.component';
import { BrfInnerFundPerRentalObjectComponent as BrfInnerFundPerRentalObjectComponent } from './report/component/brf-inner-fund/brf-inner-fund-per-rental-object.component';
import { CheckInAndCheckOutComponent } from './report/component/checkin-and-checkout/checkin-and-checkout.component';
import { InvoiceReminderFormComponent } from './invoice/component/invoice-reminder-form/invoice-reminder-form.component';
import { NotificationSettingComponent } from './common/component/notification-setting/notification-setting.component';
import { VoidCooperativeHousingLeaseAgreementComponent } from './rent/component/void-cooperative-housing-lease-agreement/void-cooperative-housing-lease-agreement.component';
import { RentInvoicingOrderManagerComponent } from './rent/component/rent-invoicing-order-manager/rent-invoicing-order-manager.component';
import { RentInvoicingOrderFormComponent } from './rent/component/rent-invoicing-order-form/rent-invoicing-order-form.component';
import { BrfMortgagePrescriptionManagerComponent } from './rent/component/brf-mortgage-prescription-manager/brf-mortgage-prescription-manager.component';
import { PropertyTaxRentalChangesComponent } from './rent/component/property-tax-rental-manager/property-tax-rental-changes.component';

const routes: Routes = [
  { path: 'login', redirectTo: '', pathMatch: 'full' },
  { path: 'reset-password', canActivate: [AnonymousGuard], component: ResetPasswordComponent },
  { path: 'register-demo', canActivate: [AnonymousGuard], component: RegisterDemoComponent },
  { path: 'staircase-list/:id', component: StaircaseListComponent },
  {
    path: 'dh',
    canActivateChild: [AuthGuard],
    component: DashboardComponent,
    children: [
      {
        path: 'fortnox',
        component: FortnoxComponent,
        data: { header: 'FORTNOX.SELECT_COMPANY' },
      },
      {
        path: 'imdpricelists',
        canActivateChild: [ImdGuard],
        children: [
          {
            path: 'add',
            component: ImdPriceListFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CONSUMPTION.PRICELIST.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: ImdPriceListFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CONSUMPTION.PRICELIST.PRICELIST' },
          },
          { path: '', component: ImdPriceListManagerComponent },
        ],
      },
      {
        path: 'imdimports',
        canActivateChild: [ImdGuard],
        children: [
          {
            path: 'add',
            component: ImdImportAddFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CONSUMPTION.IMPORT.IMPORT_FILE' },
          },
          {
            path: 'edit/:id',
            component: ImdImportFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CONSUMPTION.IMPORT.FILE_IMPORT' },
          },
          { path: '', component: ImdImportManagerComponent },
        ],
      },
      {
        path: 'imdmetermodels',
        canActivateChild: [ImdGuard],
        children: [
          {
            path: 'add',
            component: ImdMeterModelFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CONSUMPTION.METER_MODEL.METER_MODEL' },
          },
          {
            path: 'edit/:id',
            component: ImdMeterModelFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CONSUMPTION.METER_MODEL.METER_MODEL' },
          },
          { path: '', component: ImdMeterModelManagerComponent },
        ],
      },
      {
        path: 'articles',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'add',
            component: ArticleFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'ARTICLE.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: ArticleFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'ARTICLE.EDIT_HEADER' },
          },
          { path: '', component: ArticleMultiSelectManagerComponent },
        ],
      },
      {
        path: 'article-groups',
        data: { header: 'ARTICLE_GROUP.ARTICLE_GROUPS' },
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'add',
            component: ArticleGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'ARTICLE_GROUP.ARTICLE_GROUP' },
          },
          {
            path: 'edit/:id',
            component: ArticleGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'ARTICLE_GROUP.ARTICLE_GROUP' },
          },
          { path: '', component: ArticleGroupMultiSelectManagerComponent },
        ],
      },
      {
        path: 'appendix',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'add',
            component: AppendixFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'APPENDIX.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: AppendixFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'APPENDIX.EDIT_HEADER' },
          },
          { path: '', component: AppendixManagerComponent },
        ],
      },
      {
        path: 'index-clause-settings',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'add',
            component: IndexClauseSettingsFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'INDEX_CLAUSE_SETTINGS.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: IndexClauseSettingsFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'INDEX_CLAUSE_SETTINGS.EDIT_HEADER' },
          },
          { path: '', component: IndexClauseSettingsManagerComponent },
        ],
      },
      {
        path: 'custom-property',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'add',
            component: CustomPropertyFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CUSTOM_PROPERTY.FORM.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: CustomPropertyFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CUSTOM_PROPERTY.FORM.EDIT_HEADER' },
          },
          { path: '', component: CustomPropertyManagerComponent },
        ],
      },
      {
        path: 'component-category',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'add',
            component: ObjectComponentCategoryFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'COMPONENT.CATEGORY_FORM.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: ObjectComponentCategoryFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'COMPONENT.CATEGORY_FORM.EDIT_HEADER' },
          },
          { path: '', component: ObjectComponentCategoryManagerComponent },
        ],
      },
      {
        path: 'keytypes',
        children: [
          {
            path: 'add',
            component: KeyTypeFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'KEYTYPE.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: KeyTypeFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'KEYTYPE.EDIT_HEADER' },
          },
          { path: '', component: KeyTypeManagerComponent },
        ],
      },
      {
        path: 'fee-change',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'add',
            component: FeeChangeAddFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'FEE_CHANGE.IMPORT_XLSX_HEADER' },
          },
          {
            path: 'edit/:id',
            component: FeeChangeFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'LEASE_AGREEMENT.RENTAL_CHANGES_HEADER' },
          },
          { path: '', component: FeeChangeManagerComponent },
        ],
      },
      {
        path: 'rent-application',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'add',
            component: RentApplicationFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'RENT_APPLICATION.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: RentApplicationFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'RENT_APPLICATION.EDIT_HEADER' },
          },
          { path: '', component: RentApplicationManagerComponent },
        ],
      },
      {
        canActivate: [LicenseHomepalDashboardGuard],
        path: 'homepal-dashboards',
        component: HomepalDashboardsComponent,
      },
      { path: 'property-overview', component: PropertyViewComponent },
      { path: 'rental-object-rent-loss', component: RentalObjectRentLossReportComponent },
      { path: 'month-analysis-amount', component: MonthAnalysisAmountComponent },
      { path: 'invoiced-per-rental-object', component: InvoicedPerRentalObjectComponent },
      { path: 'checkin-and-checkout-list', component: CheckInAndCheckOutComponent },
      { path: 'not-fully-paid-invoice', component: NotFullyPaidInvoiceComponent },
      { path: 'account-balance-per-invoice', component: AccountBalancePerInvoiceComponent },
      { path: 'inner-fund-per-rental-object', component: BrfInnerFundPerRentalObjectComponent },
      { path: 'rent-roll', component: RentRollComponent },
      { path: 'membership-list', component: MembershipListComponent },
      { path: 'vat-report', component: VatReportComponent },
      { path: 'voluntary-tax-liability', component: VoluntaryTaxLiabilityComponent },
      { path: 'staircase-report', component: StaircaseReportComponent },
      { path: 'tax-reduction-report', component: TaxReductionReportComponent },
      { path: 'reasonableness-control', component: ReasonablenessControlComponent },
      { path: 'bgmax-import', canActivate: [InvoicingGuard], component: BgMaxImportFormComponent },
      { path: 'change-password', component: ChangePasswordComponent },
      { path: 'direct-debit', canActivate: [InvoicingGuard], component: DirectDebitComponent },
      { path: 'direct-debit-log', canActivate: [InvoicingGuard], component: DirectDebitLogManagerComponent },
      { path: 'b2c-subscriptions', canActivate: [InvoicingGuard], component: B2CSubscriptionsComponent },
      {
        path: 'print-order',
        canActivate: [InvoicingGuard],
        component: PrintOrderManagerComponent,
        data: { invoicingReadFeature: Features.ShowPrintOrders },
      },
      { path: 'bg-payments', canActivate: [InvoicingGuard], component: BgPaymentManagerComponent },
      { path: 'help', component: HelpPageComponent },
      { path: 'notification-setting', component: NotificationSettingComponent },
      {
        path: 'esignature-errand',
        canActivate: [MessagesGuard],
        children: [
          {
            path: 'add',
            component: ESignatureErrandFormComponent,
            data: { header: 'ESIGNATURE.ERRAND' },
          },
          {
            path: 'edit/:id',
            component: ESignatureErrandFormComponent,
            data: { header: 'ESIGNATURE.ERRAND' },
          },
          { path: '', component: EsignatureErrandManagerComponent },
        ],
      },
      {
        path: 'dwelling-inspection',
        loadChildren: () => import('./dwelling-inspection/dwelling-inspection.module').then(m => m.DwellingInspectionModule),
      },
      {
        path: 'co-housing',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'contracts',
            children: [
              {
                path: 'add',
                component: CooperativeHousingContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'COOPERATIVE_HOUSING.NEW_COOPERATIVE_HOUSING_AGREEMENT' },
              },
              {
                path: 'edit/:id',
                component: CooperativeHousingContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.COOPERATIVE_HOUSING_HEADER' },
              },
              { path: ':id/invoices', component: LeaseAgreementInvoicesComponent },
              { path: ':leaseAgreementId/esign-leaseagreement-documents', component: ESignLeaseAgreementDocumentComponent },
              { path: ':leaseAgreementId/transfer', component: BrfTransferComponent },
              { path: ':leaseAgreementId/documents', component: LeaseAgreementDocumentManagerComponent },
              { path: ':leaseAgreementId/rent-periods', component: LeaseAgreementRentPeriodManagerComponent },
              { path: ':leaseAgreementId/void-leaseagreement', component: VoidCooperativeHousingLeaseAgreementComponent },
              { path: '', component: CooperativeHousingContractManagerComponent },
            ],
          },
        ],
      },
      {
        path: 'dwelling',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'contracts',
            children: [
              {
                path: 'add',
                component: DwellingContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.DWELLING_HEADER' },
              },
              {
                path: 'edit/:id',
                component: DwellingContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.DWELLING_HEADER' },
              },
              { path: ':id/invoices', component: LeaseAgreementInvoicesComponent },
              { path: ':leaseAgreementId/terminate-leaseagreement', component: TerminateLeaseAgreementComponent },
              { path: ':leaseAgreementId/void-leaseagreement', component: VoidLeaseAgreementComponent },
              { path: ':leaseAgreementId/esign-leaseagreement-documents', component: ESignLeaseAgreementDocumentComponent },
              { path: ':leaseAgreementId/esign-key-reciept-document', component: ESignKeyRecieptDocumentComponent },
              { path: ':leaseAgreementId/documents', component: LeaseAgreementDocumentManagerComponent },
              { path: ':leaseAgreementId/rent-periods', component: LeaseAgreementRentPeriodManagerComponent },
              { path: '', component: DwellingContractManagerComponent },
            ],
          },
        ],
      },
      {
        path: 'other-rental-object',
        canActivate: [RentGuard],
        children: [
          {
            path: 'contracts',
            children: [
              {
                path: 'add',
                component: OtherContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.OTHER_HEADER' },
              },
              {
                path: 'edit/:id',
                component: OtherContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.OTHER_HEADER' },
              },
              { path: 'edit/:id/invoices', pathMatch: 'full', redirectTo: 'invoices' },
              { path: ':id/invoices', component: LeaseAgreementInvoicesComponent },
              { path: ':leaseAgreementId/terminate-leaseagreement', component: TerminateLeaseAgreementComponent },
              { path: ':leaseAgreementId/void-leaseagreement', component: VoidLeaseAgreementComponent },
              { path: ':leaseAgreementId/esign-leaseagreement-documents', component: ESignLeaseAgreementDocumentComponent },
              { path: ':leaseAgreementId/esign-key-reciept-document', component: ESignKeyRecieptDocumentComponent },
              { path: ':leaseAgreementId/documents', component: LeaseAgreementDocumentManagerComponent },
              { path: ':leaseAgreementId/rent-periods', component: LeaseAgreementRentPeriodManagerComponent },
              {
                path: 'terminated',
                component: OtherContractManagerComponent,
                data: { filter: { status: LeaseAgreementStatus.Terminated } },
              },
              { path: '', component: OtherContractManagerComponent },
            ],
          },
        ],
      },
      {
        path: 'parking',
        canActivate: [RentGuard],
        children: [
          {
            path: 'contracts',
            children: [
              {
                path: 'add',
                component: ParkingContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.PARKING_HEADER' },
              },
              {
                path: 'edit/:id',
                component: ParkingContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.PARKING_HEADER' },
              },
              { path: 'edit/:id/invoices', pathMatch: 'full', redirectTo: 'invoices' },
              { path: ':id/invoices', component: LeaseAgreementInvoicesComponent },
              { path: ':leaseAgreementId/terminate-leaseagreement', component: TerminateLeaseAgreementComponent },
              { path: ':leaseAgreementId/void-leaseagreement', component: VoidLeaseAgreementComponent },
              { path: ':leaseAgreementId/esign-leaseagreement-documents', component: ESignLeaseAgreementDocumentComponent },
              { path: ':leaseAgreementId/esign-key-reciept-document', component: ESignKeyRecieptDocumentComponent },
              { path: ':leaseAgreementId/documents', component: LeaseAgreementDocumentManagerComponent },
              { path: ':leaseAgreementId/rent-periods', component: LeaseAgreementRentPeriodManagerComponent },
              {
                path: 'terminated',
                component: ParkingContractManagerComponent,
                data: { filter: { status: LeaseAgreementStatus.Terminated } },
              },
              { path: '', component: ParkingContractManagerComponent },
            ],
          },
        ],
      },
      {
        path: 'premises',
        canActivate: [RentGuard],
        children: [
          {
            path: 'contracts',
            children: [
              {
                path: 'add',
                component: PremisesContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.PREMISES_HEADER' },
              },
              {
                path: 'edit/:id',
                component: PremisesContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.PREMISES_HEADER' },
              },
              { path: 'edit/:id/invoices', pathMatch: 'full', redirectTo: 'invoices' },
              { path: ':id/invoices', component: LeaseAgreementInvoicesComponent },
              { path: ':leaseAgreementId/terminate-leaseagreement', component: TerminateLeaseAgreementComponent },
              { path: ':leaseAgreementId/void-leaseagreement', component: VoidLeaseAgreementComponent },
              { path: ':leaseAgreementId/esign-leaseagreement-documents', component: ESignLeaseAgreementDocumentComponent },
              { path: ':leaseAgreementId/esign-key-reciept-document', component: ESignKeyRecieptDocumentComponent },
              { path: ':leaseAgreementId/documents', component: LeaseAgreementDocumentManagerComponent },
              { path: ':leaseAgreementId/rent-periods', component: LeaseAgreementRentPeriodManagerComponent },
              {
                path: 'terminated',
                component: PremisesContractManagerComponent,
                data: { filter: { status: LeaseAgreementStatus.Terminated } },
              },
              { path: '', component: PremisesContractManagerComponent },
            ],
          },
        ],
      },
      {
        path: 'fault-notification',
        loadChildren: () => import('./fault-notification/fault-notification.module').then(m => m.FaultNotificationModule),
      },
      {
        path: 'standalone-errands',
        loadChildren: () => import('./standalone-errand/standalone-errand.module').then(m => m.StandaloneErrandModule),
      },
      { path: 'errands', loadChildren: () => import('./deviation-errand/deviation-errand.module').then(m => m.DeviationErrandModule) },
      { path: 'rounding', loadChildren: () => import('./round-planning/round-planning.module').then(m => m.RoundPlanningModule) },
      {
        path: 'authority-inspection',
        loadChildren: () => import('./authority-inspection/authority-inspection.module').then(m => m.AuthorityInspectionModule),
      },
      { path: 'accounting', loadChildren: () => import('./accounting/accounting.module').then(m => m.AccountingModule) },
      {
        path: 'incorrect-payments',
        canActivate: [InvoicingGuard],
        data: { invoicingReadFeature: Features.ShowIncorrectPayments },
        children: [
          {
            path: 'edit/:id',
            component: IncorrectPaymentFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'INCORRECT_PAYMENT.EDIT_HEADER' },
          },
          { path: '', component: IncorrectPaymentListComponent },
        ],
      },
      {
        path: 'unhandled-bank-transactions',
        canActivateChild: [InvoicingGuard],
        data: { invoicingReadFeature: Features.ShowBankTransactionImports },
        children: [
          {
            path: 'edit/:id',
            component: UnhandledBankTransactionFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'BANK_IMPORT_TRANSACTIONS.EDIT_BANK_TRANSACTION_IMPORT' },
          },
          { path: '', component: UnhandledBankTransactionImportManagerComponent },
        ],
      },
      {
        path: 'invoice-reminders',
        canActivateChild: [InvoicingGuard],
        data: { invoicingReadFeature: Features.ShowInvoiceReminders },
        children: [
          {
            path: 'edit/:id',
            component: InvoiceReminderFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'INVOICE.EDIT_INVOICE_REMINDER_HEADER' },
          },
          { path: '', component: InvoiceReminderListComponent },
        ],
      },
      {
        path: 'contact-balance-transactions',
        component: ContactBalanceTransactionListComponent,
        canActivate: [InvoicingGuard],
        data: { invoicingReadFeature: Features.ShowContactBalanceTransactions },
      },
      { path: 'landlords', loadChildren: () => import('./landlord/landlord.module').then(m => m.LandlordModule) }, // TODO: missing canActivate
      {
        path: 'rent-invoicing',
        canActivateChild: [InvoicingGuard],
        children: [
          {
            path: 'edit/:id',
            component: RentInvoicingOrderFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'RENT_INVOICING_ORDER.RENT_INVOICING_ORDER' },
          },
          { path: 'add-single', component: CreateLeaseAgreementInvoicesComponent },
          { path: 'add', component: RentInvoicingOrderFormComponent, data: { header: 'RENT_INVOICING_ORDER.RENT_INVOICING_ORDER' } },
          { path: '', component: RentInvoicingOrderManagerComponent },
        ],
      },
      {
        path: 'invoices',
        canActivateChild: [InvoicingGuard],
        data: { invoicingReadFeature: Features.ShowInvoices },
        children: [
          //{ path: 'create', component: CreateInvoicesComponent },
          {
            path: 'edit/:id',
            component: InvoiceFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'INVOICE.EDIT_HEADER' },
          },
          {
            path: 'add',
            component: CreateInvoiceFormComponent,
            data: { header: 'INVOICE.CREATE.NEW_HEADER', invoicingWriteFeature: Features.ManageInvoices },
          },
          { path: '', component: InvoiceListComponent },
        ],
      },
      {
        path: 'debt-collection',
        canActivateChild: [InvoicingGuard],
        data: { invoicingReadFeature: Features.ShowDebtCollectionCases },
        children: [
          {
            path: 'edit/:id',
            component: DebtCollectionFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'DEBT_COLLECTION.ERRAND' },
          },
          { path: '', component: DebtCollectionManagerComponent },
        ],
      },
      {
        path: 'amortization-plan',
        canActivateChild: [InvoicingGuard],
        data: { invoicingReadFeature: Features.ShowAmortizationPlans },
        children: [
          {
            path: 'send-for-esign/:amortizationPlanId',
            component: ESignAmortizationPlanDocumentComponent,
            data: { header: 'COMMON.SEND_FOR_DIGITAL_SIGNING_DOCUMENT', invoicingWriteFeature: Features.ManageInvoices },
          },
          {
            path: 'edit/:id',
            component: AmortizationPlanDetailsComponent,
            data: { header: 'AMORTIZATION_PLAN.DETAILS_HEADER' },
          },
          { path: '', component: AmortizationPlanManagerComponent },
        ],
      },
      {
        path: 'amortization-plan-payment-notices',
        canActivateChild: [InvoicingGuard],
        data: { invoicingReadFeature: Features.ShowAmortizationPlanPaymentNotices },
        children: [
          {
            path: 'create',
            component: CreateAmortizationPlanPaymentNoticePageComponent,
            data: { header: 'AMORTIZATION_PLAN.PAYMENT_NOTICE.TITLE', invoicingWriteFeature: Features.ManageInvoices },
          },
          {
            path: 'edit/:id',
            component: AmortizationPlanDetailsComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'AMORTIZATION_PLAN.DETAILS_HEADER' },
          },
          { path: '', component: AmortizationPlanPaymentNoticeManagerComponent },
        ],
      },
      {
        path: 'invoice-row-group',
        data: { header: 'INVOICE_ROW_GROUP.INVOICE_ROW_GROUP', invoicingReadFeature: Features.ShowInvoiceRowGroups },
        canActivateChild: [InvoicingGuard],
        children: [
          {
            path: 'add',
            component: InvoiceRowGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'INVOICE_ROW_GROUP.INVOICE_ROW_GROUP', invoicingWriteFeature: Features.InvoiceRowGroup },
          },
          {
            path: 'edit/:id',
            component: InvoiceRowGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'INVOICE_ROW_GROUP.INVOICE_ROW_GROUP' },
          },
          { path: '', component: InvoiceRowGroupMultiSelectManagerComponent },
        ],
      },
      {
        path: 'mail',
        canActivateChild: [MessagesGuard],
        children: [
          {
            path: 'add',
            redirectTo: '/dh/mail/sent/add',
            pathMatch: 'full',
          },
          {
            path: 'edit/:id',
            redirectTo: '/dh/mail/sent/edit/:id',
            pathMatch: 'full',
          },
          { path: 'recipients', component: SendTenantMailsComponent },
          {
            path: 'sendmail',
            component: SendTenantMailsFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'MULTI_TENANT_FORM.HEADER' },
          },
          {
            path: 'sent',
            children: [
              {
                path: 'add',
                component: LetterFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'MAIL_FORM.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: LetterFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'MAIL_FORM.EDIT_HEADER' },
              },
              { path: '', component: MailManagerComponent },
            ],
          },
          { path: '', redirectTo: '/dh/mail/sent', pathMatch: 'full' },
        ],
      },
      {
        path: 'sms',
        canActivateChild: [MessagesGuard],
        children: [
          {
            path: 'add',
            redirectTo: '/dh/sms/sent/add',
            pathMatch: 'full',
          },
          {
            path: 'edit/:id',
            redirectTo: '/dh/sms/sent/edit/:id',
            pathMatch: 'full',
          },
          { path: 'recipients', component: SendTenantSmsComponent },
          {
            path: 'sendsms',
            component: SendTenantSMSFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'MULTI_TENANT_FORM.HEADER_SMS' },
          },
          {
            path: 'sent',
            children: [
              {
                path: 'add',
                component: SendTenantSMSFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'DASHBOARD.MENU.SEND_TENANT_SMS' },
              },
              {
                path: 'edit/:id',
                component: SmsFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'COMMON.SMS' },
              },
              { path: '', component: SmsManagerComponent },
            ],
          },
          { path: '', redirectTo: '/dh/sms/sent', pathMatch: 'full' },
        ],
      },
      {
        path: 'email',
        canActivateChild: [MessagesGuard],
        children: [
          {
            path: 'send-generic',
            component: SendGenericEmailFormComponent,
          },
          {
            path: 'add',
            redirectTo: '/dh/email/sent/add',
            pathMatch: 'full',
          },
          {
            path: 'edit/:id',
            redirectTo: '/dh/email/sent/edit/:id',
            pathMatch: 'full',
          },
          { path: 'recipients', component: SendTenantEmailsComponent },
          {
            path: 'sendemail',
            component: SendTenantEmailFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'DASHBOARD.MENU.SEND_TENANT_EMAIL' },
          },
          {
            path: 'sent',
            children: [
              {
                path: 'add',
                component: SendSingleNewEmailFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'DASHBOARD.MENU.SEND_TENANT_EMAIL' },
              },
              {
                path: 'edit/:id',
                component: EmailFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'COMMON.EMAIL' },
              },
              { path: '', component: EmailManagerComponent },
            ],
          },
          { path: '', redirectTo: '/dh/email/sent', pathMatch: 'full' },
        ],
      },
      {
        path: 'my-property',
        canActivateChild: [RentGuard],
        children: [
          {
            path: 'building',
            children: [
              {
                path: 'add',
                component: BuildingFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'BUILDING_FORM.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: BuildingFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'BUILDING_FORM.EDIT_HEADER' },
              },
              { path: '', component: BuildingManagerComponent },
              { path: ':buildingId/documents', component: BuildingDocumentManagerComponent },
            ],
          },
          {
            path: 'building-space-type',
            canActivateChild: [RentGuard],
            children: [
              {
                path: 'add',
                component: BuildingSpaceTypeFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'BUILDING_SPACE_TYPE.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: BuildingSpaceTypeFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'BUILDING_SPACE_TYPE.EDIT_HEADER' },
              },
              { path: '', component: BuildingSpaceTypeManagerComponent },
            ],
          },
          {
            path: 'letting-feature',
            canActivateChild: [LettingFeatureGuard],
            children: [
              {
                path: 'add',
                component: LettingFeatureFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LETTING_FEATURE.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: LettingFeatureFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LETTING_FEATURE.EDIT_HEADER' },
              },
              { path: '', component: LettingFeatureManagerComponent },
            ],
          },
          {
            path: 'company',
            children: [
              {
                path: 'add',
                component: CompanyFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'COMPANY.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: CompanyFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'COMPANY.EDIT_HEADER' },
              },
              { path: '', component: CompanyManagerComponent },
            ],
          },
          {
            path: 'property',
            children: [
              {
                path: 'add',
                component: PropertyFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'PROPERTY.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: PropertyFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'PROPERTY.EDIT_HEADER' },
              },
              { path: '', component: PropertyManagerComponent },
              { path: 'property-tax-rental-changes', component: PropertyTaxRentalChangesComponent },
            ],
          },
          {
            path: 'dwelling',
            canActivateChild: [RentGuard],
            children: [
              {
                path: 'add',
                component: DwellingFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'DWELLING_FORM.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: DwellingFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'DWELLING_FORM.EDIT_HEADER' },
              },
              { path: '', component: DwellingRentalObjectManagerComponent },
              { path: ':id/invoices', component: RentalObjectInvoicesComponent },
              { path: 'rental-changes', component: RentalChangesComponent },
              { path: ':rentalObjectId/documents', component: RentalObjectDocumentManagerComponent },
              { path: ':rentalObjectId/advertisments', pathMatch: 'full', redirectTo: 'edit/:rentalObjectId' },
              {
                path: ':rentalObjectId/advertisments',
                canActivateChild: [LettingAdvertismentGuard],
                children: [
                  {
                    path: 'add',
                    component: LettingAdvertismentFormComponent,
                    canDeactivate: [PendingChangesGuard],
                    data: { header: 'LETTING.ADVERTISMENT.CREATE_HEADER' },
                  },
                  {
                    path: 'edit/:id',
                    component: LettingAdvertismentFormComponent,
                    canDeactivate: [PendingChangesGuard],
                    data: { header: 'LETTING.ADVERTISMENT.EDIT_HEADER' },
                  },
                ],
              },
              {
                path: 'send-to-homeq',
                component: SendToHomeqFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'RENTAL_OBJECT.COMMAND.SEND_TO_HOMEQ' },
              },
            ],
          },
          {
            path: 'other-rental-object',
            canActivate: [RentGuard],
            children: [
              {
                path: 'add',
                component: OtherRentalObjectFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'OTHER_RENTAL_OBJECT_FORM.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: OtherRentalObjectFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'OTHER_RENTAL_OBJECT_FORM.EDIT_HEADER' },
              },
              { path: '', component: OtherRentalObjectManagerComponent },
              { path: 'rental-changes', component: RentalChangesComponent },
              { path: ':id/invoices', component: RentalObjectInvoicesComponent },
              { path: ':rentalObjectId/documents', component: RentalObjectDocumentManagerComponent },
            ],
          },
          {
            path: 'parking',
            canActivate: [RentGuard],
            children: [
              {
                path: 'add',
                component: ParkingFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'PARKING_FORM.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: ParkingFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'PARKING_FORM.EDIT_HEADER' },
              },
              { path: '', component: ParkingRentalObjectManagerComponent },
              { path: 'rental-changes', component: RentalChangesComponent },
              { path: ':id/invoices', component: RentalObjectInvoicesComponent },
              { path: ':rentalObjectId/documents', component: RentalObjectDocumentManagerComponent },
              { path: ':rentalObjectId/advertisments', pathMatch: 'full', redirectTo: 'edit/:rentalObjectId' },
              {
                path: ':rentalObjectId/advertisments',
                canActivateChild: [LettingAdvertismentGuard],
                children: [
                  {
                    path: 'add',
                    component: LettingAdvertismentParkingFormComponent,
                    canDeactivate: [PendingChangesGuard],
                    data: { header: 'LETTING.ADVERTISMENT.CREATE_HEADER' },
                  },
                  {
                    path: 'edit/:id',
                    component: LettingAdvertismentParkingFormComponent,
                    canDeactivate: [PendingChangesGuard],
                    data: { header: 'LETTING.ADVERTISMENT.EDIT_HEADER' },
                  },
                ],
              },
            ],
          },
          {
            path: 'premises',
            canActivate: [RentGuard],
            children: [
              {
                path: 'add',
                component: PremisesFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'PREMISES_FORM.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: PremisesFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'PREMISES_FORM.EDIT_HEADER' },
              },
              { path: '', component: PremisesRentalObjectManagerComponent },
              { path: 'rental-changes', component: RentalChangesComponent },
              { path: ':id/invoices', component: RentalObjectInvoicesComponent },
              { path: ':rentalObjectId/documents', component: RentalObjectDocumentManagerComponent },
              { path: ':rentalObjectId/advertisments', pathMatch: 'full', redirectTo: 'edit/:rentalObjectId' },
              {
                path: ':rentalObjectId/advertisments',
                canActivateChild: [LettingAdvertismentGuard],
                children: [
                  {
                    path: 'add',
                    component: LettingAdvertismentPremisesFormComponent,
                    canDeactivate: [PendingChangesGuard],
                    data: { header: 'LETTING.ADVERTISMENT.CREATE_HEADER' },
                  },
                  {
                    path: 'edit/:id',
                    component: LettingAdvertismentPremisesFormComponent,
                    canDeactivate: [PendingChangesGuard],
                    data: { header: 'LETTING.ADVERTISMENT.EDIT_HEADER' },
                  },
                ],
              },
            ],
          },
          {
            path: 'rental-object-keys',
            children: [
              {
                path: 'add',
                component: RentalObjectKeyFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'KEYTYPE.ADD_KEY' },
              },
              {
                path: 'edit/:id',
                component: RentalObjectKeyFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'RENTALOBJECT_KEY.EDIT_KEY' },
              },
              { path: '', component: RentalObjectKeyManagerComponent },
            ],
          },
          {
            path: 'rental-object-type',
            children: [
              {
                path: 'add',
                component: RentalObjectTypeFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'RENTAL_OBJECT_TYPE_FORM.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: RentalObjectTypeFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'RENTAL_OBJECT_TYPE_FORM.EDIT_HEADER' },
              },
              { path: '', component: RentalObjectTypeManagerComponent },
            ],
          },
        ],
      },
      {
        path: 'posts',
        canActivateChild: [MessagesGuard],
        children: [
          {
            path: 'add',
            component: PostFormComponent,
            data: { header: 'POST.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: PostFormComponent,
            data: { header: 'POST.EDIT_HEADER' },
          },
          { path: '', component: PostManagerComponent },
        ],
      },
      { path: 'profile', canActivate: [LandlordAccountGuard], component: ProfileComponent },
      { path: 'settings', canActivate: [LandlordAccountGuard], component: ProfileSettingsComponent },
      {
        path: 'block',
        canActivate: [RentGuard],
        children: [
          {
            path: 'contracts',
            children: [
              {
                path: 'add',
                component: BlockContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.BLOCK_HEADER' },
              },
              {
                path: 'edit/:id',
                component: BlockContractFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LEASE_AGREEMENT.BLOCK_HEADER' },
              },
              { path: 'edit/:id/invoices', pathMatch: 'full', redirectTo: 'invoices' },
              { path: ':id/invoices', component: LeaseAgreementInvoicesComponent },
              { path: ':leaseAgreementId/terminate-leaseagreement', component: TerminateLeaseAgreementComponent },
              { path: ':leaseAgreementId/void-leaseagreement', component: VoidLeaseAgreementComponent },
              { path: ':leaseAgreementId/esign-leaseagreement-documents', component: ESignLeaseAgreementDocumentComponent },
              { path: ':leaseAgreementId/esign-key-reciept-document', component: ESignKeyRecieptDocumentComponent },
              { path: ':leaseAgreementId/documents', component: LeaseAgreementDocumentManagerComponent },
              { path: ':leaseAgreementId/rent-periods', component: LeaseAgreementRentPeriodManagerComponent },
              {
                path: 'terminated',
                component: BlockContractManagerComponent,
                data: { filter: { status: LeaseAgreementStatus.Terminated } },
              },
              { path: '', component: BlockContractManagerComponent },
            ],
          },
        ],
      },
      {
        path: 'tenants',
        canActivate: [RentGuard],
        children: [
          {
            path: 'add',
            component: ContactFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'TENANT.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: ContactFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'TENANT.EDIT_HEADER' },
          },
          { path: ':id/invoices', component: TenantInvoicesComponent },
          { path: 'tenant/mail', component: SendTenantMailsComponent },
          { path: '', component: ContactManagerComponent },
        ],
      },
      {
        path: 'brf-transfers',
        canActivate: [RentGuard],
        children: [
          {
            path: 'edit/:id',
            component: CooperativeHousingTransferFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'COOPERATIVE_HOUSING.TRANSFER' },
          },
          { path: '', component: CooperativeHousingTransferManagerComponent },
          { path: 'pre-transfer/:rentalObjectId', component: BrfPreTransferComponent },
        ],
      },
      {
        path: 'brf-mortgage_prescriptions',
        canActivate: [RentGuard],
        children: [
          { path: '', component: BrfMortgagePrescriptionManagerComponent },
        ],
      },
      {
        path: 'cd-export',
        canActivate: [RentGuard],
        children: [
          {
            path: 'edit/:id',
            component: ControlDataExportFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CONTROL_DATA.CONTROL_DATA_EXPORT' },
          },
          {
            path: 'add',
            component: ControlDataExportFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CONTROL_DATA.CONTROL_DATA_EXPORT_CREATE' },
          },
          { path: '', component: ControlDatExportManagerComponent },
        ],
      },
      {
        path: 'cd-55',
        canActivate: [RentGuard],
        children: [
          {
            path: 'edit/:id',
            component: ControlData55FormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'CONTROL_DATA.FORM_KU55' },
          },
        ],
      },
      {
        path: 'users',
        canActivate: [LandlordAccountGuard],
        children: [
          { path: 'add', component: UserFormComponent, canDeactivate: [PendingChangesGuard], data: { header: 'USER.CREATE_HEADER' } },
          { path: 'edit/:id', component: UserFormComponent, canDeactivate: [PendingChangesGuard], data: { header: 'USER.EDIT_HEADER' } },
          { path: '', component: UserManagerComponent },
        ],
      },
      {
        path: 'user-groups',
        canActivate: [LandlordAccountGuard],
        children: [
          {
            path: 'add',
            component: UserGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'USERGROUP.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: UserGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'USERGROUP.EDIT_HEADER' },
          },
          { path: '', component: UserGroupManagerComponent },
        ],
      },
      {
        path: 'location-access-groups',
        canActivate: [LandlordAccountGuard],
        children: [
          {
            path: 'add',
            component: LocationAccessGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'LOCATION_ACCESS.GROUP_LIST_HEADER' },
          },
          {
            path: 'edit/:id',
            component: LocationAccessGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'LOCATION_ACCESS.GROUP_LIST_HEADER' },
          },
          { path: '', component: LocationAccessGroupManagerComponent },
        ],
      },
      {
        path: 'executor-groups',
        canActivate: [LandlordAccountGuard],
        children: [
          {
            path: 'add',
            component: ExecutorGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'EXECUTORGROUP.CREATE_HEADER' },
          },
          {
            path: 'edit/:id',
            component: ExecutorGroupFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'EXECUTORGROUP.EDIT_HEADER' },
          },
          { path: '', component: ExecutorGroupManagerComponent },
        ],
      },
      {
        path: 'pricelists',
        canActivateChild: [CommonPricelistsGuardService],
        children: [
          {
            path: 'add',
            component: PriceListFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'PRICELIST.PRICELIST' },
          },
          {
            path: 'edit/:id',
            component: PriceListFormComponent,
            data: { header: 'PRICELIST.PRICELIST' },
          },
          {
            path: ':priceListId/edit-item/:id',
            component: PriceListItemFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'PRICELIST.PRICELIST_ITEM_NAME' },
          },
          {
            path: ':priceListId/add-item',
            component: PriceListItemFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'PRICELIST.PRICELIST_ITEM_NAME' },
          },
          { path: '', component: PriceListManagerComponent },
        ],
      },
      {
        path: 'vacantdwelling',
        canActivate: [RentGuard],
        children: [
          {
            path: 'edit/:id',
            component: DwellingFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'DWELLING_FORM.EDIT_HEADER' },
          },
          { path: '', component: VacantPeriodDwellingManagerComponent },
          { path: ':id/invoices', component: RentalObjectInvoicesComponent },
          { path: ':rentalObjectId/documents', component: RentalObjectDocumentManagerComponent },
          { path: ':rentalObjectId/advertisments', pathMatch: 'full', redirectTo: 'edit/:rentalObjectId' },
          {
            path: ':rentalObjectId/advertisments',
            canActivateChild: [LettingAdvertismentGuard],
            children: [
              {
                path: 'add',
                component: LettingAdvertismentFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LETTING.ADVERTISMENT.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: LettingAdvertismentFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LETTING.ADVERTISMENT.EDIT_HEADER' },
              },
            ],
          },
        ],
      },
      {
        path: 'vacantother-rental-object',
        canActivate: [RentGuard],
        children: [
          {
            path: 'edit/:id',
            component: OtherRentalObjectFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'OTHER_RENTAL_OBJECT_FORM.EDIT_HEADER' },
          },
          { path: '', component: VacantPeriodOtherManagerComponent },
          { path: ':id/invoices', component: RentalObjectInvoicesComponent },
          { path: ':rentalObjectId/documents', component: RentalObjectDocumentManagerComponent },
        ],
      },
      {
        path: 'vacantparking',
        canActivate: [RentGuard],
        children: [
          {
            path: 'edit/:id',
            component: ParkingFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'PARKING_FORM.EDIT_HEADER' },
          },
          { path: '', component: VacantPeriodParkingManagerComponent },
          { path: ':id/invoices', component: RentalObjectInvoicesComponent },
          { path: ':rentalObjectId/documents', component: RentalObjectDocumentManagerComponent },
          { path: ':rentalObjectId/advertisments', pathMatch: 'full', redirectTo: 'edit/:rentalObjectId' },
          {
            path: ':rentalObjectId/advertisments',
            canActivateChild: [LettingAdvertismentGuard],
            children: [
              {
                path: 'add',
                component: LettingAdvertismentParkingFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LETTING.ADVERTISMENT.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: LettingAdvertismentParkingFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LETTING.ADVERTISMENT.EDIT_HEADER' },
              },
            ],
          },
        ],
      },
      {
        path: 'vacantpremises',
        canActivate: [RentGuard],
        children: [
          {
            path: 'edit/:id',
            component: PremisesFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'PREMISES_FORM.EDIT_HEADER' },
          },
          { path: '', component: VacantPeriodPremisesManagerComponent },
          { path: ':id/invoices', component: RentalObjectInvoicesComponent },
          { path: ':rentalObjectId/documents', component: RentalObjectDocumentManagerComponent },
          { path: ':rentalObjectId/advertisments', pathMatch: 'full', redirectTo: 'edit/:rentalObjectId' },
          {
            path: ':rentalObjectId/advertisments',
            canActivateChild: [LettingAdvertismentGuard],
            children: [
              {
                path: 'add',
                component: LettingAdvertismentPremisesFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LETTING.ADVERTISMENT.CREATE_HEADER' },
              },
              {
                path: 'edit/:id',
                component: LettingAdvertismentPremisesFormComponent,
                canDeactivate: [PendingChangesGuard],
                data: { header: 'LETTING.ADVERTISMENT.EDIT_HEADER' },
              },
            ],
          },
        ],
      },
      {
        canActivate: [MortgageGuard],
        path: 'company-mortgage',
        children: [
          {
            path: 'add',
            component: CompanyMortgageFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'MORTGAGE.COMPANY_MORTGAGE_CREATE' },
          },
          {
            path: 'edit/:id',
            canDeactivate: [PendingChangesGuard],
            component: CompanyMortgageFormComponent,
            data: { header: 'MORTGAGE.COMPANY_MORTGAGE_EDIT' },
          },
          { path: '', component: CompanyMortgageManagerComponent },
        ],
      },
      {
        canActivate: [MortgageGuard],
        path: 'credit-institute',
        children: [
          {
            path: 'add',
            component: CreditInstituteFormComponent,
            canDeactivate: [PendingChangesGuard],
            data: { header: 'MORTGAGE.CREDIT_INSTITUTE_CREATE' },
          },
          {
            path: 'edit/:id',
            canDeactivate: [PendingChangesGuard],
            component: CreditInstituteFormComponent,
            data: { header: 'MORTGAGE.CREDIT_INSTITUTE_EDIT' },
          },
          { path: '', component: CreditInstituteManagerComponent },
        ],
      },
      { path: '', canActivate: [RentGuard], component: SystemOverviewComponent, data: { header: '' } },
      { path: '404', component: PageNotFoundComponent },
      { path: 'debug', canActivate: [() => environment?.production === false], component: DebugOverviewComponent },
      { path: '**', redirectTo: '/dh/404' },
    ],
  },
  { path: '', component: LoginComponent, canActivate: [AnonymousGuard] },
  { path: '**', redirectTo: '/dh/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
